var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#DDE5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40001 13.4C7.17321 13.4 7.80002 12.7732 7.80002 12C7.80002 11.2268 7.17321 10.6 6.40001 10.6C5.62681 10.6 5 11.2268 5 12C5 12.7732 5.62681 13.4 6.40001 13.4Z",
    fill: "#567A9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4C12.7732 13.4 13.4 12.7732 13.4 12C13.4 11.2268 12.7732 10.6 12 10.6C11.2268 10.6 10.6 11.2268 10.6 12C10.6 12.7732 11.2268 13.4 12 13.4Z",
    fill: "#567A9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 13.4C18.3732 13.4 19 12.7732 19 12C19 11.2268 18.3732 10.6 17.6 10.6C16.8268 10.6 16.2 11.2268 16.2 12C16.2 12.7732 16.8268 13.4 17.6 13.4Z",
    fill: "#567A9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPage);
export default __webpack_public_path__ + "static/media/NextPage.cb64d71edbbef1349640ac6d92e6b328.svg";
export { ForwardRef as ReactComponent };